"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerComponents = exports.encodedCookies = exports.getPercentage = exports.createAPI = exports.importModules = exports.createMutations = exports.createGetters = exports.handleAction = exports.convertKeysToSnakeCase = exports.convertKeysToCamelCase = exports.partialObject = exports.omitEmpties = exports.decodeString = exports.encodeString = exports.stringReplace = exports.queryString = exports.TIME = exports.calculateBreakpoint = exports.isMobile = exports.toFormData = exports.secureDataType = exports.jsonParse = exports.getCurrentCountry = exports.changeLocationQuery = exports.hasHistory = exports.encodedLS = exports.getPairs = exports.generatePassword = exports.miniId = exports.isEmpty = exports.sleep = void 0;
const consts_1 = require("./consts");
Object.defineProperty(exports, "TIME", { enumerable: true, get: function () { return consts_1.TIME; } });
const axios_1 = require("./axios");
Object.defineProperty(exports, "createAPI", { enumerable: true, get: function () { return axios_1.createAPI; } });
const numbers_1 = require("./numbers");
Object.defineProperty(exports, "getPercentage", { enumerable: true, get: function () { return numbers_1.getPercentage; } });
const legacy_1 = require("./legacy");
Object.defineProperty(exports, "partialObject", { enumerable: true, get: function () { return legacy_1.partialObject; } });
const cookies_1 = require("./cookies");
Object.defineProperty(exports, "encodedCookies", { enumerable: true, get: function () { return cookies_1.encodedCookies; } });
const query_string_1 = require("./query-string");
Object.defineProperty(exports, "queryString", { enumerable: true, get: function () { return query_string_1.queryString; } });
const vue_1 = require("./vue");
Object.defineProperty(exports, "registerComponents", { enumerable: true, get: function () { return vue_1.registerComponents; } });
const lodash_1 = require("lodash");
const strings_1 = require("./strings");
Object.defineProperty(exports, "stringReplace", { enumerable: true, get: function () { return strings_1.stringReplace; } });
Object.defineProperty(exports, "decodeString", { enumerable: true, get: function () { return strings_1.decodeString; } });
Object.defineProperty(exports, "encodeString", { enumerable: true, get: function () { return strings_1.encodeString; } });
const vuex_1 = require("./vuex");
Object.defineProperty(exports, "importModules", { enumerable: true, get: function () { return vuex_1.importModules; } });
Object.defineProperty(exports, "createGetters", { enumerable: true, get: function () { return vuex_1.createGetters; } });
Object.defineProperty(exports, "createMutations", { enumerable: true, get: function () { return vuex_1.createMutations; } });
Object.defineProperty(exports, "handleAction", { enumerable: true, get: function () { return vuex_1.handleAction; } });
const objects_1 = require("./objects");
Object.defineProperty(exports, "convertKeysToCamelCase", { enumerable: true, get: function () { return objects_1.convertKeysToCamelCase; } });
Object.defineProperty(exports, "convertKeysToSnakeCase", { enumerable: true, get: function () { return objects_1.convertKeysToSnakeCase; } });
Object.defineProperty(exports, "omitEmpties", { enumerable: true, get: function () { return objects_1.omitEmpties; } });
/**
 *
 * @param {number} time - How much time have to sleep
 * @param {string} unit - Unit of time ['sec'-seconds,'min'-minute,'hr'-hour]
 */
const sleep = (time = 1000, unit = 'ms') => new Promise((resolve) => {
    const ms = unit === 'sec'
        ? time * 1000 : unit === 'min'
        ? time * 60 * 1000 : unit === 'hr'
        ? time * 60 * 60 * 1000 : time;
    setTimeout(() => resolve(''), ms);
});
exports.sleep = sleep;
const isEmpty = (value) => {
    if ([undefined, null, '',].includes(value))
        return true;
    if (Array.isArray(value) && !value.length)
        return true;
    if ((0, lodash_1.isPlainObject)(value) && !Object.keys(value).length)
        return true;
    return false;
};
exports.isEmpty = isEmpty;
const miniId = (len = 5) => {
    return Math.random()
        .toString(36).slice(len <= 10 ? -len : -10);
};
exports.miniId = miniId;
const generatePassword = (config = {}) => {
    let defaultType = Object.assign({ length: 8, chars: true, numbers: true, symbols: false }, config);
    const numbers = '0123456789', symbols = "!@#$%^&*()_+><{};:.,", chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let password = '', sourceString = '';
    if (defaultType.chars)
        sourceString += chars;
    if (defaultType.numbers)
        sourceString += numbers;
    if (defaultType.symbols)
        sourceString += symbols;
    for (var i = 0, n = sourceString.length; i < defaultType.length; ++i) {
        password += sourceString.charAt(Math.floor(Math.random() * n));
    }
    return password;
};
exports.generatePassword = generatePassword;
const getPairs = (array, length = 2) => {
    let start = 0, pairs = [];
    while (start < (array.length - 1)) {
        pairs = pairs.concat([[...Array(length)].map((_, index) => array[start + index])]);
        start += 1;
    }
    return pairs;
};
exports.getPairs = getPairs;
exports.encodedLS = {
    getItem(key) {
        let data = localStorage.getItem(key);
        if (!data)
            return null;
        const [error, parsed] = (0, exports.jsonParse)((0, strings_1.decodeString)(data));
        if (!error)
            return parsed;
        return (0, exports.secureDataType)(data);
    },
    setItem(key, value) {
        localStorage.setItem(key, (0, strings_1.encodeString)(JSON.stringify(value)));
    },
    removeItem(key) {
        localStorage.removeItem(key);
    },
};
const hasHistory = () => {
    return window.history.length > 2;
};
exports.hasHistory = hasHistory;
const changeLocationQuery = (query) => {
    if (window.history.pushState) {
        const newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + query;
        window.history.pushState({ path: newurl }, '', newurl);
    }
};
exports.changeLocationQuery = changeLocationQuery;
const getCurrentCountry = () => {
    return new Promise((resolve) => {
        return fetch("https://ip2c.org/s")
            .then((res) => res.text())
            .then((response) => {
            let result = (response || "").toString();
            if (!result || result[0] !== "1")
                return resolve([null, { message: 'Error while fetching country' }]);
            return resolve([{ code: result.substring(2, 4), name: result.substring(9) }, null]);
        })
            .catch((err) => resolve([err, null]));
    });
};
exports.getCurrentCountry = getCurrentCountry;
const jsonParse = (input) => {
    try {
        const parsed = JSON.parse(input);
        return [false, parsed];
    }
    catch (_) {
        return [true, null];
    }
};
exports.jsonParse = jsonParse;
const secureDataType = (input) => {
    // Non string
    if (!(0, lodash_1.isString)(input))
        return input;
    // Empty string
    if (!input.length)
        return input;
    if (input === 'undefined')
        return undefined;
    // Possible intended string
    if (['0', '+', '-'].some(v => input.startsWith(v)))
        return input;
    // Json encoded
    const [parseError, parsedData] = (0, exports.jsonParse)(input);
    if (!parseError)
        return parsedData;
    // try to convert
    const converted = +input;
    if (isNaN(converted))
        return input;
    return converted;
};
exports.secureDataType = secureDataType;
const toFormData = (value, extra = {}) => {
    const data = Object.assign(Object.assign({}, (0, objects_1.convertKeysToSnakeCase)(value)), extra);
    const formData = new FormData();
    const traverse = (value, key) => {
        if ((0, lodash_1.isArray)(value)) {
            value.forEach((v, index) => {
                traverse(v, key ? `${key}[${index}]` : index);
            });
        }
        else if ((0, lodash_1.isPlainObject)(value)) {
            Object.entries(value).forEach(([p, v]) => {
                traverse(v, key ? `${key}[${p}]` : p);
            });
        }
        else {
            formData.append(key, value);
        }
    };
    traverse(data);
    return formData;
};
exports.toFormData = toFormData;
const isMobile = () => {
    let check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)))
        check = true; })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
};
exports.isMobile = isMobile;
const calculateBreakpoint = (width, breakpoints = {}) => {
    const { sm = 640, md = 768, lg = 1024, xl = 1280, xxl = 1536 } = breakpoints;
    return {
        // EXACT
        xs: eval(`${width} < ${sm}`),
        sm: eval(`${width} >= ${sm} && ${width} < ${md}`),
        md: eval(`${width} >= ${md} && ${width} < ${lg}`),
        lg: eval(`${width} >= ${lg} && ${width} < ${xl}`),
        xl: eval(`${width} >= ${xl} && ${width} < ${xxl}`),
        xxl: eval(`${width} >= ${xxl}`),
        // DOWN
        smAndDown: eval(`${width} < ${md}`),
        mdAndDown: eval(`${width} < ${lg}`),
        lgAndDown: eval(`${width} < ${xl}`),
        xlAndDown: eval(`${width} < ${xxl}`),
        // UP
        smAndUp: eval(`${width} >= ${sm}`),
        mdAndUp: eval(`${width} >= ${md}`),
        lgAndUp: eval(`${width} >= ${lg}`),
        xlAndUp: eval(`${width} >= ${xxl}`),
    };
};
exports.calculateBreakpoint = calculateBreakpoint;
